import React, { useEffect } from "react";
import Like from "./filtros/Like";
import Number from "./filtros/Number";
import Fecha from "./filtros/Fecha";
import SelectF from "./filtros/Select";
import CheckboxF from "./filtros/Checkbox";
import RadioF from "./filtros/RadioButton";
import AutocompletarF from "./filtros/AutocompletarF";
import InputBuscador from "./filtros/InputBuscador/InputBuscador";
import AutocompletarConFetch from "./filtros/AutocompletarConFetch";
import SetFiltros from "./setFiltros";
import { aplicarValorSelectAFiltros } from "../../helper/opcionesFiltros";

const SwitchFiltros = (props) => {
  const {
    setFiltrosAAplicar,
    id_a,
    filtrosAAplicar,
    setError,
    componente,
    actuarOnChange,
  } = props;
  useEffect(() => {
    const abortController = new AbortController();
    const sincronizarFiltros =
      props.sincronizarFiltrosDesdeBack ?? setFiltrosAAplicar;

    sincronizarFiltros((prevState) => {
      const radioYaTieneValor =
        componente === "radio" &&
        Object.prototype.hasOwnProperty.call(prevState, id_a);
      if (radioYaTieneValor) return prevState;

      const valorDefault = props.default ?? filtrosAAplicar[id_a];

      if (["select", "enum"].includes(componente)) {
        return aplicarValorSelectAFiltros({
          filtros: prevState,
          id_a,
          clave_envio: props.clave_envio,
          valor: valorDefault,
        });
      }

      return { ...prevState, [id_a]: valorDefault };
    });

    return () => {
      abortController.abort();
    };
  }, [props.default]);

  const aplicarFiltroValorActivo = new SetFiltros(
    componente,
    actuarOnChange,
    setFiltrosAAplicar,
    setError,
    props
  );

  const Componente = (() => {
    switch (componente) {
      case "like":
        return (
          <Like
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "number":
        return (
          <Number
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "fecha":
        return (
          <Fecha
            {...props}
            aplicarFiltroValorActivo={(valor, aux) => {
              aplicarFiltroValorActivo.aplicar(valor, aux);
            }}
          />
        );
      case "fecha_simple":
        return (
          <Fecha
            {...props}
            aplicarFiltroValorActivo={(valor) => {
              aplicarFiltroValorActivo.aplicar(valor);
            }}
          />
        );
      case "select":
        return (
          <SelectF
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "enum":
        return (
          <SelectF
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "checkbox":
        return (
          <CheckboxF
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "radio":
        return (
          <RadioF
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "autocompletar":
        return (
          <AutocompletarF
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "autocompletar_fetch":
        return (
          <AutocompletarConFetch
            {...props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "filtro_buscador":
        return (
          <InputBuscador
            {...props}
            cab={props}
            aplicarFiltroValorActivo={(valor) =>
              aplicarFiltroValorActivo.aplicar(valor)
            }
          />
        );
      case "grupo_filtros":
        // el grupo filtros desagrupa los filtros por backend. Esta funcion no aplica.
        return props.sc_hijos.map((h) => {
          return (
            <SwitchFiltros
              {...h}
              key={h.id_a}
              filtrosAAplicar={props.filtrosAAplicar}
              setFiltrosAAplicar={props.setFiltrosAAplicar}
              sincronizarFiltrosDesdeBack={props.sincronizarFiltrosDesdeBack}
              requeridos={props.requeridos}
              setRequeridos={props.setRequeridos}
              error={props.error}
              setError={props.setError}
              context={props.ListadoContext}
            />
          );
        });
      default:
        return <></>;
    }
  })();

  if (componente === "hidden") return <></>;
  if (componente === "grupo_filtros") return <></>;

  function calcGridColumn(cab) {
    const { grid_span, grid_area } = cab;

    if (grid_area && grid_area !== "") {
      return {
        gridArea: grid_area,
      };
    }

    if ((!grid_area || grid_area === "") && grid_span && grid_span !== "") {
      return {
        gridColumn: grid_span,
      };
    }

    return { gridColumn: "span 6 / auto" };
  }

  const grids = calcGridColumn(props);

  return (
    <div
      id={props.id_a}
      className="filtro_grid_int"
      style={Object.assign(
        {
          alignSelf:
            componente in ["like", "autocompletar", "filtro_buscador"]
              ? "center"
              : "start",
        },
        grids
      )}
    >
      {Componente}
    </div>
  );
};

export default SwitchFiltros;
